// User-facing labels for the plate material kinds delivered by /products/plates
export const PLATE_TYPE_LABELS: Record<string, string> = {
  OSB: 'OSB',
  ParticleBoardP4: 'Spanplatte P4 (SPP4)',
  ParticleBoardP5: 'Spanplatte P5 (SPP5)',
  Fermacell: 'Gipsfaser-Platte',
  Rigidur: 'Rigidur',
  Diamantx: 'DiamantX',
  ThreeLayerBoard: 'Dreischichtplatte',
  MDF: 'MDF',
  Steico: 'Steico',
}

export const getPlateTypeLabel = (kind: string): string => PLATE_TYPE_LABELS[kind] ?? kind
